// extracted by mini-css-extract-plugin
export var actionButton = "_qs-0";
export var actionMenuContainer = "_qs-i";
export var bubble = "_qs-2";
export var bubbleActionMenu = "_qs-j";
export var bubbleContext = "_qs-6";
export var bubbleItems = "_qs-7";
export var customer = "_qs-3";
export var divider = "_qs-8";
export var fileList = "_qs-9";
export var hiddenComment = "_qs-o";
export var infoAbove = "_qs-a";
export var internal = "_qs-4";
export var lightActionButton = "_qs-1";
export var link = "_qs-b";
export var merchant = "_qs-5";
export var message = "_qs-c";
export var profilePicture = "_qs-e";
export var quillToolbarContainer = "_qs-f";
export var senderDate = "_qs-g";
export var senderDateCustomer = "_qs-h";
export var senderName = "_qs-d";
export var time = "_qs-k";
export var uploadedImage = "_qs-l";
export var username = "_qs-m";
export var xsmall = "_qs-n";